// extracted by mini-css-extract-plugin
export default {"link":"RequestPassword_link__YrmTz","linkWrapper":"RequestPassword_linkWrapper__Brit5"};